import { createAction, props } from '@ngrx/store';

import { ICallableNotifications, IRespNotifications, IRespReadNotification } from '../../shared/models/NotificacionTendero';

/**
 * Obtiene las notificaciones del usuario
 */
export const getNotifications = createAction(
    '[GetNotifications] Get Notifications'
);

export const successNotifications = createAction(
    '[GetNotifications] Get Notifications Success',
    props<IRespNotifications>()
);

export const errorNotifications = createAction(
    '[GetNotifications] Get Notifications Error',
    props<{ payload: Error }>()
);

export const setReadNotification = createAction(
    '[GetNotifications] Set Read Notification',
    props<{ ID_NotificacionTendero: number; }>()
);

export const resetNotifications = createAction('[GetNotifications] Reset Notifications list');

/**
 * Actualiza Leido de la notificacion del usuario
 */
export const readNotification = createAction(
    '[ReadNotification] Read Notification',
    props<ICallableNotifications>()
);

export const successReadNotification = createAction(
    '[ReadNotification] Read Notification Success',
    props<IRespReadNotification>()
);

export const errorReadNotification = createAction(
    '[ReadNotification] Read Notification Error',
    props<{ payload: Error }>()
);

export const resetReadNotification = createAction('[ReadNotification] Reset Notification Read');
